/**
 * Pure helpers for building runnable apigen request snippets (cURL commands).
 *
 * Kept separate from the React components in `apiSnippets.tsx` so Fast Refresh
 * (react-refresh) is happy: a module should export either only components or
 * only non-components.
 */
import { APIGEN_API_BASE, APIGEN_API_KEY } from '../../utils/api';

/**
 * Resolve the absolute origin the apigen service is reachable at, so copied
 * cURL snippets are runnable as-is (not relative to the SPA).
 */
export function apigenOrigin(): string {
  return APIGEN_API_BASE.startsWith('http')
    ? APIGEN_API_BASE
    : `${typeof window !== 'undefined' ? window.location.origin : ''}${APIGEN_API_BASE}`;
}

/** Build a runnable `curl` command for a POST to `path` with a JSON `body`. */
export function buildCurl(path: string, body: Record<string, unknown>): string {
  const lines = [
    `curl -X POST '${apigenOrigin()}${path}' \\`,
    `  -H 'Content-Type: application/json' \\`,
  ];
  if (APIGEN_API_KEY) lines.push(`  -H 'X-API-Key: ${APIGEN_API_KEY}' \\`);
  lines.push(`  -d '${JSON.stringify(body)}'`);
  return lines.join('\n');
}

/** Build a runnable `curl` command for a GET to `path`. */
export function buildGetCurl(path: string): string {
  const lines = [`curl '${apigenOrigin()}${path}'`];
  if (APIGEN_API_KEY) {
    lines[0] += ` \\`;
    lines.push(`  -H 'X-API-Key: ${APIGEN_API_KEY}'`);
  }
  return lines.join('\n');
}
